import { Injectable } from '@angular/core';

@Injectable()
export class AccountEffect {
  constructor() {}
}
